import { cn } from '@/shared/lib/utils';
import { Icon } from './Icon';

interface PaginationProps {
  /** 1부터 */
  page: number;
  pageSize: number;
  totalCount: number;
  onChange: (page: number) => void;
}

const PAGE_WINDOW = 5;

const itemClassName =
  'flex size-7 shrink-0 cursor-pointer items-center justify-center rounded-24 text-body-13 font-regular text-fg-tertiary disabled:cursor-default disabled:opacity-40';

/** Figma Pagination — 28px 원형 항목, 현재 페이지는 검정 */
export function Pagination({
  page,
  pageSize,
  totalCount,
  onChange,
}: PaginationProps) {
  const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));
  const first = Math.max(
    1,
    Math.min(page - Math.floor(PAGE_WINDOW / 2), totalPages - PAGE_WINDOW + 1),
  );
  const pages = Array.from(
    { length: Math.min(PAGE_WINDOW, totalPages) },
    (_, index) => first + index,
  );

  return (
    <nav aria-label="페이지" className="flex items-center justify-center gap-1">
      <button
        type="button"
        aria-label="이전 페이지"
        className={itemClassName}
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
      >
        <Icon name="chevronLeftSmall" size={16} />
      </button>
      {pages.map((pageNumber) => (
        <button
          key={pageNumber}
          type="button"
          aria-current={pageNumber === page ? 'page' : undefined}
          className={cn(
            itemClassName,
            pageNumber === page
              ? 'bg-black text-fg-white'
              : 'hover:bg-grey-100',
          )}
          onClick={() => onChange(pageNumber)}
        >
          {pageNumber}
        </button>
      ))}
      <button
        type="button"
        aria-label="다음 페이지"
        className={itemClassName}
        disabled={page >= totalPages}
        onClick={() => onChange(page + 1)}
      >
        <Icon name="chevronRightSmall" size={16} />
      </button>
    </nav>
  );
}
